export enum EntityLevelType {
  HOME = 0,
  CLIENT = 1,
  EVENT_SERIES = 2,
  REGISTRATION = 3,
  EVENT = 4,
  PROGRAM = 5
}
